"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusFromPapermillNotebook = void 0;
var codeCapsule_1 = require("../../types/codeCapsule");
/**
 * Interpret a notebook after/while being executed by papermill
 */
function getStatusFromPapermillNotebook(notebookOutput) {
    if (notebookOutput.metadata.papermill.exception) {
        return codeCapsule_1.NotebookStatus.FAILURE;
    }
    if (notebookOutput.metadata.papermill.start_time &&
        notebookOutput.metadata.papermill.end_time) {
        return codeCapsule_1.NotebookStatus.SUCCESS;
    }
    if (notebookOutput.metadata.papermill.start_time) {
        return codeCapsule_1.NotebookStatus.IN_PROGRESS;
    }
    return undefined;
}
exports.getStatusFromPapermillNotebook = getStatusFromPapermillNotebook;
//# sourceMappingURL=notebook.js.map